import { apiClient } from "shared/api/client";

/**
 * 자료실(shareNotices) 도메인 API.
 * UI는 엔드포인트/HTTP 메서드를 모르고 이 함수들만 호출한다.
 */
/**
 * 자료실 목록 조회.
 * @param {number} [category] - 지정 시 해당 category만, createdAt DESC 정렬로 반환.
 *   미지정(undefined)이면 axios가 빈 params를 자동 제외해 전체를 반환한다(하위 호환).
 */
export const fetchShareNotices = async (category) => {
  const response = await apiClient.get("/shareNotices", {
    params: { category },
  });
  return response.data;
};

export const getShareNotice = async (id) => {
  const response = await apiClient.get(`/shareNotices/${id}`);
  return response.data;
};

export const createShareNotice = async (data) => {
  const response = await apiClient.post("/shareNotices", data);
  return response.data;
};

export const updateShareNotice = async (id, data) => {
  const response = await apiClient.patch(`/shareNotices/${id}`, data);
  return response.data;
};

export const deleteShareNotice = async (id) => {
  await apiClient.delete(`/shareNotices/${id}`);
};
